<template lang="pug">
    aside.loader(:class="tamanho")
        .ring
            i
            i
            i
            i
</template>

<script>
export default {
    name: 'component-loader',
    props: {
        tamanho: {
            default: 'small'
        }
    }
}
</script>

<style lang="stylus" scoped src="./Loader.styl"></style>